export default __webpack_public_path__ + "static/media/avatar.f2968fad.PNG";